import { Color, SvgGraphics } from '@tencent/alloy-renderer';
import { IWrapperComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/types';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

// 标记操作的框的线宽
const STROKE_WIDTH = 4;

export class HistoryMarkComponent {
    // 图形构造入参
    public factoryOptions: InterfaceFactoryOptions<IElementBaseModel>;
    // wrapper
    public readonly parentComponent: IWrapperComponent;
    // 选框
    private rectArea: SvgGraphics | null;

    public constructor(
        factoryOptions: InterfaceFactoryOptions<IElementBaseModel>,
        parentComponent: IWrapperComponent,
    ) {
        this.factoryOptions = factoryOptions;
        this.parentComponent = parentComponent;
    }

    public renderComponent(): void {
        const { model } = this.factoryOptions;
        const authorInfo = this.needRender();
        // 以下情况无需渲染
        if (!authorInfo) {
            if (this.rectArea) {
                this.parentComponent.removeChild(this.rectArea);
                this.rectArea.dispose();
                this.rectArea = null;
            }
            return;
        }
        // 渲染边框
        const hexColor = this.factoryOptions.historyManager?.getColorForId(authorInfo);
        const { width, height } = model.props.style;
        if (!this.rectArea) {
            this.rectArea = new SvgGraphics();
            this.parentComponent.addChild(this.rectArea);
        }
        this.rectArea.x = 0;
        this.rectArea.y = 0;
        this.rectArea.path = `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;
        this.rectArea.lineStyle.width = STROKE_WIDTH;
        this.rectArea.lineStyle.color = Color.fromHex(hexColor || '#000000', 0.6);
    }

    // 是否需要渲染修订记录操作痕迹边框
    private needRender() {
        if (!this.factoryOptions?.historyManager?.isShowHistoryPanel) {
            // 只有 pc editor entry 有修订记录，其他的 entry 比如远程演示等没有修订记录
            return false;
        }
        return this.getAuthInfo();
    }

    // 获取操作记录
    private getAuthInfo() {
        const { model } = this.factoryOptions;
        const changedComponents = this.factoryOptions.historyManager?.changedComponents ?? [];
        if (changedComponents.length === 0) {
            return null;
        }
        const changedComponent = changedComponents.find(item => item.components?.has(model.sdkData?.props.id));
        return changedComponent?.author;
    }
}
